module.exports = __webpack_public_path__ + "static/media/FocusArea1-2019.ebbcfa60.png";